import React from "react";

function Education() {
  return (
    <>
      <div className="container">
        <div class="box-border p-4 bg-blue-500 m4">Education</div>
      </div>
    </>
  );
}

export default Education;
